import type { BillingDocument, BillingState, Client, CompanySettings, Service } from "../types";

export const companyDefaults: CompanySettings = {
  name: "Revival Softech",
  legalName: "Revival Business Solution",
  tagline: "Innovative Technology Solutions",
  email: "hello@revivalsoftech.com",
  phone: "+91 73822 90095 / +91 90085 03639",
  website: "https://revivalsoftech.com",
  address: "Building No. 550, 14th Main Road, 7th Sector, HSR Layout, Bengaluru, Karnataka 560102, India",
  gstin: "29AQMPV4198C1Z6",
  pan: "AQMPV4198C",
  gst_rate: 18,
  terms: "Net 30",
  notes: "Thank you for your business! Payment is due within 30 days. Please include the invoice number in your payment reference.",
  bank: "HDFC Bank",
  acc: "50200012345678",
  ifsc: "HDFC0001234",
  acctype: "Current",
};

const makeService = (
  id: string,
  name: string,
  category: string,
  rate: number,
  billing: "monthly" | "one_time",
  description: string,
  features: string[],
  extras: Partial<Service> = {}
): Service => ({
  id,
  serviceId: id,
  name,
  category,
  rate,
  billing,
  unit: billing === "monthly" ? "Monthly" : "Project",
  hsn: category === "Website Development" ? "998314" : "998361",
  description,
  features,
  delivery: "",
  platforms: [],
  note: "",
  bestFor: [],
  bonus: [],
  currency: "INR",
  ...extras,
});

export const defaultServices: Service[] = [
  makeService(
    "WEB_STARTER",
    "Starter Website Package",
    "Website Development",
    14999,
    "one_time",
    "Professional business website designed to establish a strong online presence and generate customer enquiries.",
    ["Up to 5 pages", "Mobile responsive design", "Contact form", "WhatsApp integration", "Google Maps integration", "Basic SEO setup", "Speed optimization", "1 month support"],
    { delivery: "7-10 working days", bestFor: ["Small businesses", "Clinics", "Startups"] }
  ),
  makeService(
    "WEB_BUSINESS",
    "Business Website Package",
    "Website Development",
    24999,
    "one_time",
    "Advanced business website with custom design, analytics and lead generation features.",
    ["Up to 10 pages", "Custom UI design", "Blog section", "Lead generation forms", "Google Analytics setup", "SEO optimization", "Admin panel", "2 months support"],
    { delivery: "10-15 working days" }
  ),
  makeService(
    "META_STANDARD",
    "Standard Meta Ads Package",
    "Meta Ads Management",
    14999,
    "monthly",
    "Campaign management for consistent lead generation and customer acquisition.",
    ["2-3 campaigns", "Advanced targeting", "Multiple ad sets", "3-5 creatives", "Pixel setup", "Retargeting", "A/B testing", "Weekly optimization", "Detailed reports"],
    { platforms: ["Facebook", "Instagram"], note: "Ad spend not included" }
  ),
  makeService(
    "META_COMPLETE",
    "Complete Meta Ads Package",
    "Meta Ads Management",
    49999,
    "monthly",
    "Complete advertising solution focused on maximizing ROI, leads and sales.",
    ["Multiple campaign management", "Custom and lookalike audiences", "Retargeting campaigns", "8-12 ad creatives", "Conversion API setup", "Daily monitoring", "Monthly reports", "Monthly strategy call"],
    { platforms: ["Facebook", "Instagram"], note: "Ad spend not included" }
  ),
  makeService(
    "COMBO_META_WEB_CARE",
    "Meta Ads + Website Maintenance Package",
    "Growth Combo Packages",
    40000,
    "monthly",
    "All-in-one monthly growth package combining Meta advertising with ongoing website maintenance.",
    ["Meta Ads campaign management", "Advanced audience targeting", "Pixel and conversion tracking", "Monthly ad creatives", "Website maintenance and updates", "Security updates", "Performance monitoring", "Monthly backup", "Technical support"],
    { platforms: ["Facebook", "Instagram"], note: "Ad spend not included" }
  ),
  makeService(
    "SOCIAL_BASIC",
    "Basic Social Media Package",
    "Social Media Management",
    24999,
    "monthly",
    "Consistent social media management and engagement.",
    ["20 posts per month", "8 reels", "Story management", "Caption writing", "Hashtag research", "Creative designing", "Comment management", "Monthly report"],
    { platforms: ["Facebook", "Instagram"] }
  ),
];

export const seededClients: Client[] = [
  {
    id: "client-surya-speciality-pharma",
    name: "Suresh T",
    company: "Surya speciality Pharma",
    email: "suresht@suryaspacialitypharma.com",
    phone: "8618359321",
    address: "1st Floor, Vittal Square, 1249, 25F Cross, 24th Main Rd, 2nd Sector, HSR Layout, Bengaluru, Karnataka 560102",
    gstin: "",
    industry: "Pharmaceuticals & Healthcare",
  },
  {
    id: "client-theo-spa",
    name: "Management",
    company: "Theo Spa",
    email: "theospa2025@gmail.com",
    phone: "9886563105",
    address: "70, 1st floor, Begur Rd, opp ZUDIO, Vishwapriya Nagar, Begur, Bengaluru, Karnataka 560114",
    gstin: "",
    industry: "Beauty & Wellness",
  },
  {
    id: "client-vasavi-hospitals",
    name: "Accounts Dept",
    company: "Vasavi Hospitals",
    email: "accounts@vasavihospitals.com",
    phone: "98442 12748",
    address: "15, 70th Cross Road, 1st Stage, Kumaraswamy Layout, Bengaluru, Karnataka 560111",
    gstin: "",
    industry: "Healthcare",
  },
];

export const seededInvoices: BillingDocument[] = [
  {
    id: "JX34QL",
    subtotal: 220000,
    date: "2026-09-07",
    gstRate: 18,
    clientId: "client-surya-speciality-pharma",
    company: "Surya speciality Pharma ",
    phone: "8618359321",
    po: "",
    createdAt: "2026-09-07T15:55:20.699Z",
    pos: "Karnataka",
    paymentMethod: "Bank Transfer / NEFT",
    due: "2026-10-07",
    items: [
      { id: "item-1", disc: 50, hsn: "998314", qty: 1, unit: "Project", amount: 27500, rate: 55000, serviceId: "", desc: "Software Architecture, Backend & Core Platform Engineering" },
      { id: "item-2", serviceId: "", disc: 50, unit: "Project", hsn: "998314", qty: 1, amount: 15000, desc: "Cross-Platform Android & iOS Application Developmen", rate: 30000 },
      { id: "item-3", amount: 20000, serviceId: "", desc: "Pharmacy, Prescription, Order & Inventory Management System", qty: 1, hsn: "998314", rate: 40000, disc: 50, unit: "Project" },
      { id: "item-4", qty: 1, serviceId: "", hsn: "998314", rate: 40000, desc: "Logistics, Shiprocket API, Geo-Fencing, Payment & Real-Time Order Integration", disc: 50, amount: 20000, unit: "Project" },
      { id: "item-5", unit: "Fixed", amount: 25000, disc: 0, serviceId: "", desc: "Annual Maintenance, Technical Support, Security & System Management – 12 Months", rate: 25000, qty: 1, hsn: "998314" },
      { id: "item-6", desc: "Administration, Analytics & Production Deployment", amount: 15000, serviceId: "", rate: 30000, unit: "Project", qty: 1, disc: 50, hsn: "998314" }
    ],
    total: 144550,
    gstAmt: 22050,
    number: "INV-0089",
    address: "1st Floor, Vittal Square, 1249, 25F Cross, 24th Main Rd, 2nd Sector, HSR Layout, Bengaluru, Karnataka 560102",
    type: "invoice",
    status: "sent",
    notes: "Thank you for your business! Payment is due within 30 days. Please include the invoice number in your payment reference.",
    discTotal: 97500,
    email: "suresht@suryaspacialitypharma.com",
    clientGstin: "",
    sourceQuoteId: "Q1PQCW",
    currency: "INR"
  },
  {
    id: "IY2EJ2",
    po: "",
    discTotal: 0,
    pos: "Karnataka",
    due: "2026-09-16",
    address: "70, 1st floor, Begur Rd, opp ZUDIO, Vishwapriya Nagar, Begur, Bengaluru, Karnataka 560114",
    sourceQuoteId: "D8YIHU",
    date: "2026-08-17",
    subtotal: 35000,
    clientId: "client-theo-spa",
    notes: "Thank you for your business! Payment is due within 30 days. Please include the invoice number in your payment reference.",
    email: "theospa2025@gmail.com",
    company: "Theo Spa",
    phone: "9886563105",
    paymentMethod: "Bank Transfer / NEFT",
    clientGstin: "",
    currency: "INR",
    gstRate: 0,
    total: 35000,
    items: [
      { id: "item-7", serviceId: "", disc: 0, unit: "Monthly", hsn: "998361", qty: 1, amount: 15000, desc: "Meta Ads", rate: 15000 },
      { id: "item-8", disc: 0, unit: "Monthly", qty: 1, serviceId: "", hsn: "998361", amount: 15000, desc: "Google Ads", rate: 15000 },
      { id: "item-9", unit: "Fixed", amount: 3000, disc: 0, serviceId: "", desc: "Website Management", rate: 3000, hsn: "998314", qty: 1 },
      { id: "item-10", desc: "SEO", amount: 2000, rate: 2000, serviceId: "", unit: "Fixed", qty: 1, disc: 0, hsn: "998361" }
    ],
    createdAt: "2026-08-17T07:10:58.126Z",
    status: "paid",
    type: "invoice",
    number: "INV-0088",
    gstAmt: 0
  },
  {
    id: "VE2VF5",
    currency: "INR",
    items: [
      { id: "item-11", qty: 1, desc: "Lead Generation Package", amount: 21200, hsn: "998361", rate: 21200, disc: 0, serviceId: "META_LEAD_GEN", unit: "Monthly" }
    ],
    total: 25016,
    pos: "Karnataka",
    due: "2026-08-19",
    company: "Vasavi Hospitals",
    date: "2026-07-20",
    createdAt: "2026-07-20T10:17:13.854Z",
    gstRate: 18,
    phone: "98442 12748",
    paymentMethod: "Bank Transfer / NEFT",
    email: "accounts@vasavihospitals.com",
    notes: "Thank you for your business! Payment is due within 30 days. Please include the invoice number in your payment reference.",
    gstAmt: 3816,
    number: "INV-0086",
    status: "sent",
    clientGstin: "",
    discTotal: 0,
    sourceQuoteId: "AAU6GN",
    subtotal: 21200,
    po: "",
    address: "15, 70th Cross Road, 1st Stage, Kumaraswamy Layout, Bengaluru, Karnataka 560111",
    type: "invoice",
    clientId: "client-vasavi-hospitals"
  },
  {
    id: "SXS49L",
    gstRate: 18,
    date: "2026-07-10",
    subtotal: 16949.15,
    sourceQuoteId: "L71E5F",
    company: "Theo Spa",
    clientId: "client-theo-spa",
    discTotal: 0,
    phone: "+91 98865 63105",
    due: "2026-08-09",
    status: "paid",
    pos: "Karnataka",
    gstAmt: 3050.85,
    number: "INV-0085",
    items: [
      { id: "item-12", unit: "Monthly", amount: 16949.15, disc: 0, serviceId: "META_STANDARD", rate: 16949.15, hsn: "998361", desc: "Standard Ads Package", qty: 1 }
    ],
    total: 20000,
    notes: "Thank you for your business!",
    po: "",
    currency: "INR",
    paymentMethod: "Bank Transfer / NEFT",
    createdAt: "2026-07-10T09:00:00.000Z",
    address: "70, 1st floor, Begur Rd, opp ZUDIO, Vishwapriya Nagar, Begur, Bengaluru, Karnataka 560114",
    email: "theospa2025@gmail.com",
    clientGstin: "",
    type: "invoice"
  }
];

export const seededQuotes: BillingDocument[] = [
  {
    id: "Q1PQCW",
    subtotal: 220000,
    date: "2026-09-01",
    gstRate: 18,
    clientId: "client-surya-speciality-pharma",
    company: "Surya speciality Pharma",
    phone: "8618359321",
    po: "",
    createdAt: "2026-09-01T10:00:00.000Z",
    pos: "Karnataka",
    paymentMethod: "Bank Transfer / NEFT",
    due: "2026-09-30",
    items: [
      { id: "item-q1", disc: 50, hsn: "998314", qty: 1, unit: "Project", amount: 27500, rate: 55000, serviceId: "", desc: "Software Architecture, Backend & Core Platform Engineering" },
      { id: "item-q2", serviceId: "", disc: 50, unit: "Project", hsn: "998314", qty: 1, amount: 15000, desc: "Cross-Platform Android & iOS Application Developmen", rate: 30000 }
    ],
    total: 50150,
    gstAmt: 7650,
    number: "QUO-0042",
    address: "1st Floor, Vittal Square, 1249, 25F Cross, 24th Main Rd, 2nd Sector, HSR Layout, Bengaluru, Karnataka 560102",
    type: "quote",
    status: "accepted",
    notes: "Quotation valid for 30 days. 50% advance upon project initiation.",
    discTotal: 42500,
    email: "suresht@suryaspacialitypharma.com",
    clientGstin: "",
    currency: "INR"
  }
];

export const emptyState: BillingState = {
  invoices: [],
  quotes: [],
  clients: [],
  services: defaultServices,
  expenses: [],
  settings: companyDefaults,
};

export const demoState: BillingState = {
  invoices: seededInvoices,
  quotes: seededQuotes,
  clients: seededClients,
  services: defaultServices,
  expenses: [
    { id: "exp-claude", date: "2026-10-01", nextBillingDate: "2026-11-01", category: "Software", description: "Claude Code Subscription", vendor: "Anthropic", amount: 1800, recurrence: "monthly", paymentMethod: "Credit Card", notes: "AI Pair Programming & Code Generation for Engineering Team", status: "active" },
    { id: "exp-1", date: "2026-09-15", nextBillingDate: "2026-10-15", category: "Infrastructure", description: "Vercel Pro Subscription", vendor: "Vercel Inc.", amount: 1700, recurrence: "monthly", paymentMethod: "Credit Card", notes: "Production frontend hosting", status: "active" },
    { id: "exp-2", date: "2026-09-20", nextBillingDate: "2026-10-20", category: "Infrastructure", description: "Google Cloud Platform Services", vendor: "Google Cloud", amount: 3450, recurrence: "monthly", paymentMethod: "Credit Card", notes: "Firebase & Cloud Functions", status: "active" },
    { id: "exp-3", date: "2026-09-28", nextBillingDate: "2027-09-28", category: "Domain & DNS", description: "Cloudflare Business & Domains", vendor: "Cloudflare", amount: 2100, recurrence: "annual", paymentMethod: "Credit Card", notes: "revivalsoftech.com domain protection", status: "active" }
  ],
  settings: companyDefaults,
};
